import { render } from "./columnProductName.vue?vue&type=template&id=5db778b5&ts=true"
import script from "./columnProductName.vue?vue&type=script&lang=ts"
export * from "./columnProductName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__